/**
 * TanStack Router: /workforce/employees
 *
 * This route file was auto-generated by the route generation script.
 * Component: WorkforceEmployeesPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import WorkforceEmployeesPage from '@/app/workforce/employees/page'

/**
 * Route: /workforce/employees
 * Layout: _auth (authenticated)
 * Component: WorkforceEmployeesPage
 */
export const Route = createFileRoute('/_auth/workforce/employees/')({
  component: WorkforceEmployeesPage,
})
